export enum Routes {
  BoardingPass = '/rooms/:roomId',
  ChatVideo = '/rooms/:roomId/video',
  Form = '/form/region/:region',
  Rating = '/rooms/:roomId/rating',
  SelectRegion = '/form/region',
  Thanks = '/rooms/:roomId/thanks',
}
